import stylesTheme from "../stylesTheme";

export const MuiForm = {
  MuiOutlinedInput: {
    root: {
      backgroundColor: "white",
      borderRadius: "4px",
    },
  },
  MuiFormHelperText: {
    root: {
      color: stylesTheme.palette.text.primary,
      fontSize: stylesTheme.typography.pxToRem(12),
      fontWeight: 600,
    },
    contained: {
      marginLeft: 0,
      marginRight: 0,
    },
  },
};
